export const sectionConfig = {
  1: {
    class: 'section'
  },
  2: {
    class: 'section'
  },
  3: {
    class: 'section section-complete'
  },
  5: {
    class: 'section section-complete'
  },
  6: {
    class: 'section' //Section complete
  },
  8: {
    class: 'section section-padding'
  },
  9: {
    class: 'section section-bottom'
  },
  10: {
    class: 'section section-background'
  },
  11: {
    class: 'section section-complete'
  },
  13: {
    class: 'section section-background'
  },
  14: {
    class: 'section container',
  },
  15: {
    class: 'section',
  },
  16: {
    class: 'section',
  },
  17: {
    class: 'section section-background',
  },
  18: {
    class: 'section section-bottom',
  },
  19: {
    class: 'section',
  },
  20: {
    class: 'section section-complete',
  },
}
